export default __webpack_public_path__ + "apple-touch-icon.5075c699d0e0d52314a1894a57d3de2d.png";